<header class="app-header" *ngIf="mostrarHeader">
  <div class="header-content">
    <ul class="links inline-block">
      <li class="links-item float-left p-2">
        <ibs-ui-dropdown>
          <button class="emissao-dropdown-trigger" ibsUiDropdownTrigger type="button">
            Emissão
            <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </button>
          <ibs-ui-dropdown-content>
            <ibs-ui-dropdown-item (selected)="navegarParaEmissao()">Emissão Kafka</ibs-ui-dropdown-item>
            <ibs-ui-dropdown-item (selected)="navegarParaDuimp()">Emissão DUIMP</ibs-ui-dropdown-item>
          </ibs-ui-dropdown-content>
        </ibs-ui-dropdown>
      </li>
      <li class="links-item float-left p-2"><a routerLink="/pagamentos">Pagamentos</a></li>
      <li class="links-item float-left p-2 menu-grupo" (mouseenter)="menuRecepcaoAberto = true" (mouseleave)="menuRecepcaoAberto = false">
        <button type="button" class="menu-grupo-gatilho" [class.ativo]="naRecepcao" aria-haspopup="true"
          [attr.aria-expanded]="menuRecepcaoAberto" (click)="menuRecepcaoAberto = !menuRecepcaoAberto">
          Recep&ccedil;&atilde;o de Conv&ecirc;nios
          <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 10l5 5 5-5z"/>
          </svg>
        </button>
        <div class="dropdown-menu menu-grupo-itens" [class.show]="menuRecepcaoAberto" role="menu">
          <a class="dropdown-item" role="menuitem" routerLink="/painel-recepcao" routerLinkActive="ativo"
            (click)="menuRecepcaoAberto = false">Painel</a>
          <a class="dropdown-item" role="menuitem" routerLink="/validacao-arquivos" routerLinkActive="ativo"
            (click)="menuRecepcaoAberto = false">Acompanhamento da Valida&ccedil;&atilde;o</a>
          <a class="dropdown-item" role="menuitem" routerLink="/rastreio-pagamento" routerLinkActive="ativo"
            (click)="menuRecepcaoAberto = false">Rastreio do Pagamento</a>
          <a class="dropdown-item" role="menuitem" routerLink="/parametros-recepcao" routerLinkActive="ativo"
            (click)="menuRecepcaoAberto = false">Par&acirc;metros</a>
        </div>
      </li>
      <li class="links-item float-left p-2"><a routerLink="/dias-uteis">Dias Úteis</a></li>
      <li class="links-item float-left p-2"><a routerLink="/quarentena">Quarentena</a></li>
    </ul>
    <div class="user-menu" (mouseenter)="abrirDropdown()" (mouseleave)="fecharDropdown()">
      <div class="user-info">
        <svg class="user-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
        <span class="user-name">{{ usuarioLogado?.nome }}</span>
        <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </div>
      <div class="dropdown-menu" [class.show]="dropdownAberto">
        <button class="dropdown-item" (click)="deslogar()">
          <svg class="logout-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
          </svg>
          Deslogar
        </button>
      </div>
    </div>
  </div>
</header>
<div class="main-content" [class.with-header]="mostrarHeader">
  <router-outlet></router-outlet>
</div>
